import appConfig from "app.config";
import createHttpRequest from "utils/createHttpRequest";

const dxInterceptionApi = createHttpRequest(appConfig.apiUrl);

export default dxInterceptionApi;
